"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var count = 0;
exports.objectIndex = function (obj) {
    if (typeof obj.__uniqueid === 'undefined') {
        Object.defineProperty(obj, '__uniqueid', {
            value: ++count,
            enumerable: false,
            writable: false,
        });
    }
    return "obj@" + obj.__uniqueid;
};
//# sourceMappingURL=objectIndexer.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/utils/objectIndexer.js
// module id = 1894
// module chunks = 0